/**
 * Computes the list of appearance IDs that are available for a given size,
 * or all in-stock sellable appearances when no size is selected.
 */
export const getAvailableAppearanceIds = (
  productType: ClientProductType,
  sellable: Sellable,
  sizeId: string | undefined
): string[] =>
  productType.appearanceIds.filter(
    (appearanceId) =>
      sellable.allowedAppearances.includes(Number(appearanceId)) &&
      productType.stockStates.some(
        (stockState) =>
          stockState.appearance.id === appearanceId &&
          (sizeId === undefined || stockState.size.id === sizeId) &&
          stockState.available
      )
  );

/**
 * Computes the list of size IDs that are available for a given appearance.
 */
export const getAvailableSizeIds = (
  productType: ClientProductType,
  appearanceId: string
): string[] =>
  productType.sizes
    .filter((size) =>
      productType.stockStates.some(
        (stockState) =>
          stockState.appearance.id === appearanceId &&
          stockState.size.id === size.id &&
          stockState.available
      )
    )
    .map((size) => size.id);
